import Vue from 'vue';
import {loading, htmlReady} from '@/components/utils/common';
import Mixins from '@/components/mixins/';

import App from './app.vue';
import {store} from './store/';

import '@/scss/index.scss';

class Entry {
	constructor() {
		loading('#knd-app-2');

		store.dispatch("fetchData").then(() => {
			this.renderApp('#knd-app-2', App);
		})

	}

	renderApp(id, Comp) {
		if(!this.checkEl(id)) return;

		Vue.mixin(Mixins);

		new Vue({
			el: id,
			store,
			render: h => h( Comp ),
			components : { 
				Comp
			}
		});		
	}

	checkEl(id) {
		// check if element id exists on page
		let el = document.querySelector(id);
		if(!el) {
			console.log(el, ' does not exist');
			return;
		}
		return true;
	}
}

htmlReady(() => {
	const start = new Entry();
})

